import {Select} from "@/theme/ui";
import {useApi} from "@/lib/hook";

export const CountrySelect = (
    {
        value,
        onChange,
        isCountryStatistic = false,
        ...rest
    }
) => {
    const {data} = useApi({
        route: {name: 'admins.countries.all'},
        setting: {
            select: (data) => data.data,
            staleTime: Infinity,
        }
    })

    return (
        <>
            <Select
                showSearch
                style={{
                    maxWidth: isCountryStatistic ? '287px' : '100%',
                    width: '100%',
                }}
                value={value}
                onChange={onChange}
                mode={isCountryStatistic ? 'default' : 'multiple'}
                options={data?.map(item => ({
                    value: item.id,
                    label: (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <img
                                src={item.path}
                                alt={item.name}
                                style={{ width: 20, height: 15, objectFit: 'cover', borderRadius: 2 }}
                            />
                            {item.name}
                        </div>
                    ),
                    name: item.name,
                }))}
                filterOption={(input, option) =>
                    option?.name?.toLowerCase().includes(input.toLowerCase())
                }
                {...rest}
            />
        </>
    );
}